export default __webpack_public_path__ + "static/media/last-page.2bf37649.svg";